/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TrackCollaboratorNotificationActionData
 */
export interface TrackCollaboratorNotificationActionData {
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotificationActionData
     */
    trackId: string;
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotificationActionData
     */
    inviterUserId: string;
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotificationActionData
     */
    collaboratorUserId: string;
    /**
     * Current collaborator invite status at response time.
     * @type {string}
     * @memberof TrackCollaboratorNotificationActionData
     */
    status?: TrackCollaboratorNotificationActionDataStatusEnum;
}


/**
 * @export
 */
export const TrackCollaboratorNotificationActionDataStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected'
} as const;
export type TrackCollaboratorNotificationActionDataStatusEnum = typeof TrackCollaboratorNotificationActionDataStatusEnum[keyof typeof TrackCollaboratorNotificationActionDataStatusEnum];


/**
 * Check if a given object implements the TrackCollaboratorNotificationActionData interface.
 */
export function instanceOfTrackCollaboratorNotificationActionData(value: object): value is TrackCollaboratorNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "trackId" in value && value["trackId"] !== undefined;
    isInstance = isInstance && "inviterUserId" in value && value["inviterUserId"] !== undefined;
    isInstance = isInstance && "collaboratorUserId" in value && value["collaboratorUserId"] !== undefined;

    return isInstance;
}

export function TrackCollaboratorNotificationActionDataFromJSON(json: any): TrackCollaboratorNotificationActionData {
    return TrackCollaboratorNotificationActionDataFromJSONTyped(json, false);
}

export function TrackCollaboratorNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackCollaboratorNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'trackId': json['track_id'],
        'inviterUserId': json['inviter_user_id'],
        'collaboratorUserId': json['collaborator_user_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function TrackCollaboratorNotificationActionDataToJSON(value?: TrackCollaboratorNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'track_id': value.trackId,
        'inviter_user_id': value.inviterUserId,
        'collaborator_user_id': value.collaboratorUserId,
        'status': value.status,
    };
}
